<template>
  <div class="home">
    <div class="banner">
      <img
        class="banner_img"
        src="../../static/img/news_banner.png"
        alt=""
      >
    </div>
    <ul class="content w1200">
        <li  v-for="(item,i) in newList" :key="i" @click="$router.push({path:item.path })">
            <img class="con_x" :src="item.img" alt="">
            <div class="con_y">
                <h4>{{item.bt}}</h4>
                <span>{{item.date}}</span>
                <span>天津协和万邦</span>
                <p>{{item.text}}</p>

            </div>
        </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
        newList: [
            {
                img: require('../../static/img/news_tu1.png'),
                bt: '强强联手 新模式开启新天地--项目合作圆满召开',
                date: '2018-12-05',
                text: '2018年12月05日，天津协和万邦保险经纪公司在公司大厦成功举办与北京飞猪科技公司项目合作启动大会，双方在通过科技创新的深度合作上迈出了实质性的一步。',
                path: '/newsContent?id=0'
            },
            {
                img: require('../../static/img/news_tu2.png'),
                bt: '弘扬真善美 传递正能量 公司开展学雷锋志愿服务活动',
                date: '2018-11-20',
                text: '11月20日，公司共产党员服务队、青年志愿者服务队联合都城管理中心前往浦东新区的残障疗养院开展学习雷锋主题日活动，以实际行动传承雷锋精神。在疗养院，志愿者们深入了解了残障人士的生活和身体情况，参观了疗养院中的复活动室、心理咨询室以及残障人士亲手制作的精美手工制品和绿色环保作品，感受到了他们积极的人生态度和自强自立的精神意志。',
                path: '/newsContent?id=1'
            },
            {
                img: require('../../static/img/news_tu3.png'),
                bt: '防范非法集资小问答',
                date: '2018-09-18',
                text: '如何识别保险领域的非法集资？解答：消费过程中要尽量做到“三查、两配合”，即通过保险公司网站、客户热线或保监会、行业协会网站查人员、查产品、查单证，配合做好转账缴费、配合做好回访。',
                path: '/newsContent?id=2'
            },
            {
                img: require('../../static/img/news_tu4.png'),
                bt: '公司组织全体员工集中观看电影《厉害了，我的国》',
                date: '2018-06-15',
                text: '06月15日，公司组织单位全体员工集中观看了大型纪录电影《厉害了，我的国》。',
                path: '/newsContent?id=3'
            },
            {
                img: require('../../static/img/news_tu5.png'),
                bt: '防控风险 守住底线',
                date: '2017-09-12',
                text: '保险业是经营风险的特殊行业。最近，中国保监会发出《关于进一步加强保险业风险防控工作的通知》，内容涉及9项风险十大举措，核心紧扣保险业的风险防范。在当前中国经济、中国金融面临诸多复杂不利局面的形势下，出台这样一个防控保险业风险的文件可谓正逢其时。',
                path: '/newsContent?id=4'
            }
        ]
    }
  }
}
</script>

<style  lang="scss" scoped>
.content{
    padding: 0 50px;
    background-color: #fff;
    li{
        padding: 60px 0;
        display: flex;
        border-bottom: 2px solid #cacaca;
        cursor: pointer;
        .con_y{
            padding-left: 55px;
            h4{
                font-size: 30px;
                color: #323232;
                font-weight: 600;
                line-height: 50px;
            }
            span{
                font-size: 14px;
                color: #b0b0b0;
                
            }
            p{
                color: #686868;
                font-size: 18px;
                padding-top: 30px;
            }
        }
    }
    li:hover .con_y>h4{
        color: #5377c3;
        transition: all .7s;
    }
li:nth-last-of-type(1){
    border: 0;
}
}
</style>



// WEBPACK FOOTER //
// src/pages/News.vue